import React, { useState, useEffect } from 'react';
import { apiFetch } from '../App';

export default function LeaderboardPage() {
  const [leaders, setLeaders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/api/web/leaderboard').then(setLeaders).catch(console.error).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div style={{ marginBottom:24 }}>
        <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:28, letterSpacing:1.5, marginBottom:4 }}>LEADERBOARD</div>
        <div style={{ fontSize:13, color:'var(--text2)' }}>Top predictors ranked by wins and accuracy</div>
      </div>

      {loading ? (
        <div style={{ textAlign:'center', padding:40, color:'var(--muted)' }}>Loading...</div>
      ) : (
        <div className="card" style={{ padding:0, overflow:'hidden' }}>
          {/* Header */}
          <div style={{ display:'grid', gridTemplateColumns:'40px 1fr 80px 80px 80px', gap:12, padding:'12px 20px', borderBottom:'1px solid var(--border)', fontSize:11, color:'var(--muted)', fontWeight:600, letterSpacing:.5 }}>
            <div>RANK</div><div>PLAYER</div><div style={{ textAlign:'center' }}>WINS</div><div style={{ textAlign:'center' }}>ACCURACY</div><div style={{ textAlign:'right' }}>EARNED</div>
          </div>
          {leaders.map((u, i) => (
            <div key={i} style={{ display:'grid', gridTemplateColumns:'40px 1fr 80px 80px 80px', gap:12, padding:'14px 20px', borderBottom:'1px solid var(--border)', alignItems:'center',
              background: i===0?'rgba(245,200,66,.04)':i===1?'rgba(200,200,200,.02)':i===2?'rgba(205,127,50,.02)':'transparent' }}>
              <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:18, color: i===0?'#f5c842':i===1?'#c0c0c0':i===2?'#cd7f32':'var(--muted)' }}>
                {i===0?'🥇':i===1?'🥈':i===2?'🥉':`#${i+1}`}
              </div>
              <div>
                <div style={{ fontSize:14, fontWeight:600 }}>{u.first_name||'User'}</div>
                <div style={{ fontSize:11, color:'var(--muted)' }}>@{u.username||'—'}</div>
              </div>
              <div style={{ textAlign:'center', fontWeight:700, color:'#00c566' }}>{u.wins}</div>
              <div style={{ textAlign:'center' }}>
                <span style={{ fontSize:13, fontWeight:600, color: u.accuracy>=70?'#00c566':u.accuracy>=50?'#f5c842':'var(--text2)' }}>{u.accuracy}%</span>
              </div>
              <div style={{ textAlign:'right', fontSize:13, fontWeight:700, color:'#f5c842' }}>{u.total_won||0} ⭐</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
